import React, {InputHTMLAttributes} from "react";
import styles from "./RadioButton.module.scss";

type RadioButtonProps = {
  color?: string;
  wrapperClassName?: string;
} & InputHTMLAttributes<HTMLInputElement>;

const RadioButton: React.FC<RadioButtonProps> = ({children, checked, onChange, wrapperClassName = "", name, value}) => {
  return (
    <div className={`${styles.wrapper} ${wrapperClassName}`}>
      <label className={styles.label} style={{cursor: checked ? "default" : "pointer"}}>
        <input type={"radio"} name={name} value={value} checked={checked} onChange={onChange} />
        {children}
      </label>
    </div>
  );
};

export default RadioButton;
